import { render, staticRenderFns } from "./Expert.vue?vue&type=template&id=56105d7b&"
import script from "./Expert.vue?vue&type=script&lang=js&"
export * from "./Expert.vue?vue&type=script&lang=js&"
import style0 from "./Expert.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/clients/client11/web18/web/api/releases/20220610210856/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56105d7b')) {
      api.createRecord('56105d7b', component.options)
    } else {
      api.reload('56105d7b', component.options)
    }
    module.hot.accept("./Expert.vue?vue&type=template&id=56105d7b&", function () {
      api.rerender('56105d7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client/src/Expert.vue"
export default component.exports